import { useEffect, useState } from "react";
import { http } from "../../lib/api";

export const PreviewTab = ({ kit }) => {
  const [html, setHtml] = useState("");
  useEffect(() => {
    http.get(`/kits/${kit.id}/preview/app`, { responseType: "text" }).then((r) => setHtml(r.data));
  }, [kit.id, kit.updated_at]);
  return (
    <div className="rounded-xl border border-[#C9A847]/20 overflow-hidden bg-white">
      {html ? (
        <iframe data-testid="app-preview-iframe" title="Interactive kit preview" srcDoc={html} className="w-full h-[78vh] border-0" />
      ) : <div className="p-10 text-stone-500">Rendering app…</div>}
    </div>
  );
};
